<template>
	<div class="chat-chat-sharemsg">
		<div class="chat-chat-sharemsg-title">
			<span class="chat-chat-ht-name">消息转发：<span style="color: green;font-weight: bold;">{{selectMessage.length}}条</span>-逐条发送</span>
			<span class="chat-chat-ht-close" @click="closePage">关闭</span>
		</div>
		<div class="chat-chat-sharemsg-box" v-if="selectMessage.length > 0">
			<chat-fans-comp @sender-fans-call="senderFansCall($event)"></chat-fans-comp>
		</div>
		<div class="chat-chat-sharemsg-send" v-if="selectMessage.length > 0">
			<button @click="send">确认</button>
			<button style="background-color: red;" @click="sahreMsgCancel">取消</button>
		</div>
		<div class="chat-chat-sharemsg-empty" v-if="selectMessage.length === 0">
			<p>未选择消息，请选择消息后继续操作！</p>
		</div>
	</div>
</template>

<script>
	import ChatFansComp from '../../components/ChatFansComp.vue'
	import {sendMsg} from '../../socket/socketSender.js'
	export default{
		name:"ChatChatShareMsg",
		components:{
			ChatFansComp
		},
		props:{
			selectMessage:{
				type: Array,
				default:[]
			}
		},
		data(){
			return {
				friends:[]
			}
		},
		methods:{
			// 初始化原始数据
			initData(){
				
			},
			
			// 粉丝选择回调
			senderFansCall(data){
				this.friends = data
			},
			
			
			// 关闭页面
			closePage(){
				this.$emit('chat-sharemsg-close')
			},
			
			// 分享取消
			sahreMsgCancel(){
				this.$emit('chat-sharemsg-cancel')
			},
			
			// 发送消息
			send(){
				if(this.friends.length>1){
					CHAT_LAYER.msg("最多选择1个好友")
					return
				}
				for (let j = 0; j < this.friends.length; j++) {
					let chatUser = {
						 type: 1,
						 custom_wx_id: this.friends[j].custom_open_id,
						 fans_wx_id:this.friends[j].open_id,
						 fans_id:this.friends[j].id,
						 phone_id: this.friends[j].phone_id
					}
					for (let i = 0; i < this.selectMessage.length; i++) {
						// 判断是否为base64，如果是则上传后发送
						sendMsg(chatUser,this.selectMessage[i].content,this.selectMessage[i].type,this)
					}
				} 
				this.$emit('chat-sharemsg-cancel')
			},
		}
	}
</script>

<style>
	.chat-chat-sharemsg{
		position: absolute;
		top: 100px;
		left: 30px;
		bottom: 100px;
		right: 30px;
		background-color: #FFFFFF;
		z-index: 11;
	}
	.chat-chat-sharemsg-title{
		height: 32px;
		line-height: 32px;
		background-color: #e8e8e8;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
	}
	.chat-chat-ht-close{
		cursor: pointer;
		padding: 0 10px;
	}
	.chat-chat-sharemsg-box{
		position: absolute;
		top: 42px;
		left: 0;
		right: 0;
		bottom: 52px;
		overflow: hidden;
	}
	.chat-chat-sharemsg-send{
		position: absolute;
		height: 40px;
		bottom: 10px;
		left: 10px;
		right: 10px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		overflow: hidden;
	}
	.chat-chat-sharemsg-send button{
		border: none;
		background-color: #009E94;
		color: #FFFFFF;
		padding: 2px 6px;
		border-radius: 2px;
		margin: 0 5px;
		cursor: pointer;
	}
	.chat-chat-sharemsg-empty{
		text-align: center;
		line-height: 100px;
		color: orange;
	}
</style>
